/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

import { QueryClientProvider } from '@tanstack/react-query'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import App from 'App'
import queryClient from 'config/reactQueryClient'
import { MaterialUIControllerProvider } from 'context'

ReactDOM.render(
	<BrowserRouter>
		<QueryClientProvider client={queryClient}>
			<MaterialUIControllerProvider>
				<App />
			</MaterialUIControllerProvider>
		</QueryClientProvider>
	</BrowserRouter>,
	document.getElementById('root')
)
